export const SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP = 'SHOW_WATCH_MORE_VIDEOS_LATER_TOOLTIP';
export const SET_IS_FIRST_SHOW_INTRO = 'SET_IS_FIRST_SHOW_INTRO';